jQuery(document).ready(function($) {

  $('.alert-banner').each(function() {
    // if(localStorage.getItem('ecw_visitor_alert_closed_'+$(this).attr('data-alert-banner-id'))) {
    if(Cookies.get('ecw_visitor_alert_closed_'+$(this).attr('data-alert-banner-id'))) {
      $(this).addClass('closed');
    } else {
      $(this).removeClass('closed');
    }
  });
 
  $('[data-toggle-alert]').click(function() {
    var alertBannerID = $(this).parents('.alert-banner').attr('data-alert-banner-id');
    $('.alert-banner[data-alert-banner-id="'+alertBannerID +'"]').toggleClass('closed');

    if($(this).hasClass('alert-banner-close')) {
      // localStorage.setItem('ecw_visitor_alert_closed_'+alertBannerID, '1');
      Cookies.set('ecw_visitor_alert_closed_'+alertBannerID, '1', { expires: 1 });
    }
    if($(this).hasClass('alert-banner-open')) {
      // localStorage.removeItem('ecw_visitor_alert_closed_'+alertBannerID);
      Cookies.remove('ecw_visitor_alert_closed_'+alertBannerID);
    }
  });

});
